/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { UpdateProgramSessionDto } from './update-program-session-dto';
 /**
 *
 *
 * @export
 * @interface UpdateProgramDto
 */
export interface UpdateProgramDto {

    /**
     * @type {string}
     * @memberof UpdateProgramDto
     */
    title?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateProgramDto
     */
    mobility?: JoinEntityDto | null;

    /**
     * @type {string}
     * @memberof UpdateProgramDto
     */
    type?: UpdateProgramDtoTypeEnum;

    /**
     * @type {string}
     * @memberof UpdateProgramDto
     */
    shared?: UpdateProgramDtoSharedEnum;

    /**
     * @type {string}
     * @memberof UpdateProgramDto
     */
    note?: string | null;

    /**
     * @type {Array<UpdateProgramSessionDto>}
     * @memberof UpdateProgramDto
     */
    sessions?: Array<UpdateProgramSessionDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum UpdateProgramDtoTypeEnum {
    THERAPY = 'THERAPY',
    TRAINING = 'TRAINING'
}
/**
 * @export
 * @enum {string}
 */
export enum UpdateProgramDtoSharedEnum {
    NONE = 'NONE',
    ORGANIZATION = 'ORGANIZATION'
}

